import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Http, Headers, RequestOptions, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BaseProxyService } from '../proxy/base-proxy.service';
import { AppSettings } from '../config/settings/app-settings';
import { nscModel } from '../models/nsc/nsc.model';
import { BlroModel } from '../models/blro/blro.model';
import { error } from 'util';

import { HttpClientModule, HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Body } from '@angular/http/src/body';

import { ChatbotBasicQuestionAns } from 'app/models/chatbotBasicQuestionAns/ChatbotBasicQuestionAns';

function _window(): any {
	return window;
}

@Injectable()
export class HttpTestService {

	public nscModel: nscModel = new nscModel;
	public blroModel: BlroModel = new BlroModel();
	mobileNo: string = "";
	blroIDD: number;
	purposeIdd: number;
	transIDD: string;
	blroName: string = "";
	_baseUrl: any = "";
	headers: Headers;
	checksum: string;
	public fileExtion: string;
	public fileNO: Number;

	@Output() userLoggedIn: EventEmitter<any> = new EventEmitter();
	@Output() userLoggedOut: EventEmitter<any> = new EventEmitter();
	@Output() userdetailsObj: EventEmitter<any> = new EventEmitter();


	rechargeResponse: any = {
		flag: "T",
		message: "success",
		count: 1,
		data: [
			{
				"unit_name": "CPS7176511",
				"site_id": "c_cust_2",
				"req_connection_no": "cps6565",
				"connection_no": "cps6565",
				"req_contract_account": "",
				"contract_account": "",
				"tran_stat": "Y",
				"payable_amount": 100.12,
				"transaction_id": "PAYTM_TX_555",
				"unique_transaction_id": "f94f9f8f-bc0a-4d09-bd17-a675a2479c02-7"
			}
		]
	}



	balanceResponse: any =
		{
			flag: "T",
			message: "success",
			count: 1,
			data: [
				{
					"unit_name": "CPS7176511",
					"req_connection_no": "cps6565",
					"connection_no": "cps6565",
					"req_contract_account": "",
					"contract_account": "",
					"enquiry_date": "19-05-2023",
					"enquiry_time": "15:26:23",
					"site_id": "c_cust_2",
					"subscriber_name": "CPS7176511",
					"unit_detail": "CPS7176511 cuculus_cust_ipcl",
					"outstanding1": 239.26999999999998,
					"outstanding2": 239.26999999999998,
					"outstanding3": null,
					"outstanding4": null,
					"outstanding5": null,
					"outstanding6": null,
					"outstanding_header_1": "Current Balance",
					"outstanding_header_2": null,
					"outstanding_header_3": null,
					"outstanding_header_4": null,
					"outstanding_header_5": null,
					"outstanding_header_6": null
				}
			]
		}











	constructor(public _baseProxy: BaseProxyService,
		public http: Http,
		public _http: Http, private httpClient: HttpClient) {
		this.mobileNo = this.nscModel.newUserMob;
		this.headers = new Headers();
		this.headers.set('Content-Type', 'multipart/form-data');

	}

	getBalance() {
		return this.balanceResponse;
	}

	getTransactionResponse() {
		return this.balanceResponse;
	}

	get nativeWindow(): any {
		return _window();
	}

	//user Services

	getUserDetailsByConsNo(requestedId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.GETPERSONALDETAILSBYCONSUMERNO);
	}
	getConsumerInfoByConsumerId(requestedId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.GETCONSUMERINFOBYCONSUMERID);
	}

	authenticateUser(requestedId) {
		console.log("Login Credential: " + requestedId);
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.AUTHUSER);
	}
	newAuthenticateUser(param: any) {
		let theaders = new HttpHeaders({ "Content-Type": "application/x-www-form-urlencoded" });

		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.NEWAUTHUSER, param,
			{
				headers: theaders
			}).map(res => res);
	}

	getPayableAmount(requestedId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.GETPAYABLE);
	}

	getGayaBill(requestedId) {
		console.log("DOCUMENT ID: " + requestedId);
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.GETBILLGAYA);
	}

	getHTGayaBill(requestedId) {
		return this._baseProxy.get(AppSettings.IPCL_API + requestedId + AppSettings.GETHTGAYABILL);
	}

	getAsansolBill(requestedId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.GETBILLASANSOL);//For SAP CALL
	}

	//  getAsansolBill(requestedId){
	//  	return this._baseProxy.get(AppSettings.IPCL_API +'/' +requestedId+ AppSettings.GETBILLGAYA); // LOCAL TEST
	//  }


	getGayaBillHistory(requestedId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.GETBILLHISTORYGAYA);
	}



	getAsanBillHistory(requestedId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.GETBILLHISTORYASAN);
	}

	sendOTP(mobileNo) {
		console.log("XXXXXXXX" + mobileNo)
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + mobileNo + AppSettings.OTPSEND);
	}

	validateOTP(requestedId) {
		console.log("SERVICES: " + requestedId);
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.OTPVALIDATE);
	}

	postMobileOtpData(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.SEND_EMAIL_OTP,
			data,
			{
				headers: theaders
			})
			.map(res => res);
	}


	// getPaymentHistory(requestedId){
	// 	return this._baseProxy.get(AppSettings.IPCL_API +requestedId+ AppSettings.GETPAYMENTHISTORY);
	// }

	getPaymentHistory(requestedId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.GETCONSUMPTIONHISTORY);
	}

	getChecksum(requestedId: string) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.GETADMINCHECKSUM);
	}

	getKYC(requestedId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + requestedId + AppSettings.GETKYC);
	}

	forgotPassword(consumer) {
		//return this._baseProxy.get(AppSettings.IPCL_API + '/' + consumer + AppSettings.FORGOTPASS);
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');
		let param = {
			consumerNo: consumer
		}
		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.FORGOTPASS, param,
			{
				headers: theaders
			}).map(res => res);
	}
	forgotPasswordForNsc(emailId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + emailId + AppSettings.FORGOTPASSFORNSC);
	}
	getGeneralBroadCast() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETGENERALBROAD);
	}

	getZonalBroadCast(key, val) {
		return this._baseProxy.get(AppSettings.IPCL_API + key + "^" + val + AppSettings.GETZONALBROAD);
	}

	getAdDetails() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETADTOSHOW);
	}

	getRegionDetails() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETLOCATION);
	}

	getGrevienceDetails() {

		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETALLGREVIENCE);
	}

	getRequestdetails() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETALLREQUEST);
	}

	getGrevienceCats() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETGREVIENCECAT);
	}

	getGrevienceSubCats(catId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + catId + AppSettings.GETGREVIENCESUBCAT);
	}


	getRequestCats() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETREQUESTCAT);
	}
	getPrefixList() {
		console.log("getPrefixList Service ");
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETPREFIXLIST);

	}

	getOTPbyEmail(emailID) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + emailID + AppSettings.GETOTPBYEMAIL);

	}

	getOTPbyMobile(mobileNo) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + mobileNo + AppSettings.GETOTPBYMOBILE);
	}

	getGrevienceDetailsByConsumerNo(consumerNo) {

		return this._baseProxy.get(AppSettings.IPCL_API + '/' + consumerNo + AppSettings.GETALLGREVIENCE);
	}

	checkConsumerNo(consumerNO) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + consumerNO + AppSettings.VALIDATECONSUMERNO);
	}

	getGrivanceData(consumerNo: string) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + consumerNo + AppSettings.POSTLOGINDETAILS);

	}

	validateMobileByOTP(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.VALIDATEBYMOBILEOTP, data,
			{
				headers: theaders
			}).map(res => res);

	}
	validateConsumerNoWithOTP(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.VALIDATECONSUMERNOWITHOTP, data,
			{
				headers: theaders
			}).map(res => res);

	}



	validateEmailByOTP(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.VALIDATEBYEMAILOTP, data,
			{
				headers: theaders
			}).map(res => res);

	}
	validateConsumerNoWithPass(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + '/' + AppSettings.VALIDATECONSUMERWITHPASS,
			data,
			{
				headers: theaders
			})
			.map(res => res);

	}

	getAllBlroRegion() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETALLBLROREGION);
	}

	getZoneByBlroRegionId(blroRegionId: number) {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETZONEDATA + '/' + blroRegionId);
	}

	getBlroList() {
		console.log("BLRO DETAILS Service ");
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETBLROLIST);

	}
	getMouzaList(blroId: number) {
		this.blroIDD = blroId
		console.log("Mauza DETAILS Service" + this.blroIDD);
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + blroId + AppSettings.GETMAUZALIST);

	}

	getPurposeSupplyList(purposeSuupId: number) {

		console.log("Purpose Supply Service " + this.purposeIdd);
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + purposeSuupId + AppSettings.GETPURPOSESUPPLYLIST);

	}

	getAllPowerSupplyList() {
		console.log("Power Supply Service ");
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETPOWERSUPPLYTYPELIST);

	}

	getConnetonTypeList() {
		console.log("Connection Type Service ");
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETCONNECTIONTYPELIST);

	}

	getCatagoryTypeList() {
		console.log("Catagory Type Service ");
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETCATAGORYTYPELIST);

	}

	getAppliedPhaseList() {
		console.log("Applied Phase Service ");
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETAPPLIEDPHASELIST);

	}

	getConsumerInfo(transactionIds: string) {
		console.log("Applied Phase Service ");
		//this.transIDD = transactionIds;
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + transactionIds + AppSettings.GETCONSUMERLIST);

	}

	getEmdValue(transactionIds: string) {
		console.log("Emd Value  Service " + transactionIds);

		return this._baseProxy.get(AppSettings.IPCL_API + '/' + transactionIds + AppSettings.GETEMDVALUE);

	}
	getDocumentTypeForIdInfo() {
		console.log("getPrefixList Service ");
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETDOCUMETTYPEBYID);

	}
	getDocumentTypeForOwnInfo() {
		console.log("getPrefixList Service ");
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETDOCUMETTYPEBYOWN);

	}
	getDocumentTypeForAuthInfo() {
		console.log("getPrefixList Service ");
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETDOCUMETTYPEBYAUTH);

	}
	getTransaction(transactionId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + transactionId + AppSettings.GETTRANSACTIONID);
	}
	getMailDetails(transactionId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + transactionId + AppSettings.GETMILDETAILS);
	}

	getResendMobileOTP(transactionId: string) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + transactionId + AppSettings.GETRESENTMOBILEOTP);
	}


	getResendEmailOTP(transactionId: string) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + transactionId + AppSettings.GETRESENTEMAILOTP);
	}


	getAllLoadData() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETLOADDETAILS);
	}

	getComplainTile() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETCOMPLAINTITLE);
	}


	getCatagoryList(complainID) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + complainID + AppSettings.GETCATAGORYLIST);

	}
	getSubCatagoryList(catID) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + catID + AppSettings.GETSUBCATAGORYLIST);
	}

	getComplainDetails(consumerNo) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + consumerNo + AppSettings.GETCOMPLAINDETAILS);
	}



	createAndDownloadBillPdf(consumerNo): Observable<any> {
		return this.httpClient.get(AppSettings.IPCL_API + '/' + consumerNo + AppSettings.GENERATEBILLPDF);
	}


	createAndDownloadPdf(consumerNo): Observable<any> {
		return this.httpClient.get(AppSettings.IPCL_API + '/' + consumerNo + AppSettings.GENERATEPDF);
	}

	downloadIdentity(transID: string): Observable<any> {
		const headers = new Headers({ 'Content-Type': 'application/pdf' });
		const options = new RequestOptions({ headers: headers });
		options.responseType = ResponseContentType.Blob;
		//options.responseType = ResponseContentType.ArrayBuffer;
		this.transIDD = transID;
		return this._http.get(AppSettings.IPCL_API + this.transIDD + AppSettings.GETFILEDETAILS, options);
	}
	createUser(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.CREATEUSER,
			data,
			{
				headers: theaders
			})
			.map(res => res);
	}


	postNsc(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');
		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.POSTNSC, data, { headers: theaders }).map(res => res);
	}

	postGrievanceDetails(data) {
		console.log("XXXXXXXX===SUBMIT====XXXXXXXXXXX")
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.POSTGRIEVANCE,
			data,
			{
				headers: theaders
			})
			.map(res => res);
	}


	postNScReg(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.VALIDATEEMAIL,
			data,
			{
				headers: theaders
			})
			.map(res => res);
	}

	postNScPassReg(data) {
		console.log("XXXXXXXX===SUBMIT====XXXXXXXXXXX")
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.POSTNSCREG,
			data,
			{
				headers: theaders
			})
			.map(res => res);
	}

	postConsumerBasicDetails(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.POSTCONSUMERDETAILS, data);
	}

	postLoadDetails(data) {
		console.log("DATA: " + JSON.stringify(data));
		console.log("XXXXXXXX===Load Details Details====XXXXXXXXXXX")
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.POSTLOADDETAILS, data);
	}


	postPayEmd(data) {
		console.log("XXXXXXXX===Pay Emd Details====XXXXXXXXXXX")
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');
		console.log(data);

		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.PAYEMD, data);
	}

	postRazorpayResponse(data) {
		console.log("XXXXXXXX===Pay Emd Details====XXXXXXXXXXX")
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');
		console.log(data);

		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.SAVERAZORPAYRESPONSE, data);
	}

	sendOxigenOtp(mob, type) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');
		theaders.append('method', 'GET');
		theaders.append("Authorization", btoa(AppSettings.OXIUSER + ":" + AppSettings.OXIPASS));
		console.log(theaders);
		return this._baseProxy.getOxi(AppSettings.OXIGEN_URL + AppSettings.SEND_OXI_OTP + "?mobilenumber=" + mob + "&otptype=" + type, {
			headers: theaders
		});
	}
	postPaymentGaya(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.POSTGAYAPAYMENT,
			data,
			{
				headers: theaders
			})
			.map(res => res);
	}
	postKYC(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.ADDKYC,
			data,
			{
				headers: theaders
			})
			.map(res => res);
	}

	postAdDetails(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.ADDADDETAILS,
			data,
			{
				headers: theaders
			})
			.map(res => res);
	}

	postEmailOtpData(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');
		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.SEND_EMAIL_OTP, data, { headers: theaders }).map(res => res);
	}

	postTransactionLoginData(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.TRANSCTN_OTP_DATA,
			data,
			{
				headers: theaders
			})
			.map(res => res);
	}

	upload(fileList: FileList): Observable<any> {
		if (fileList.length > 0) {
			let file: File = fileList[0];
			let formData: FormData = new FormData();
			formData.append('identificationDoc', file, file.name);
			return this.http.post('http://192.168.1.55:8080/api/v1/uploadConsuggmerDocuments', formData, {
				headers: this.headers
			})
		}
	}

	postPaymentForNsc(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');
		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.PAYMENTNSCSEND, data, { headers: theaders }).map(res => res);
	}

	getTransactionDatatable(transactionId) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + transactionId + AppSettings.TRANSACTIONNSCSEND);
	}

	downloadDocument(consumerNo: string): Observable<any> {
		// set headers for the file and response to be Blob
		const headers = new Headers({ 'Content-Type': 'application/pdf' });
		const options = new RequestOptions({ headers: headers });
		options.responseType = ResponseContentType.Blob;
		//options.responseType = ResponseContentType.ArrayBuffer;
		return this.http.get(`${AppSettings.IPCL_API}${AppSettings.DOWNLOADORVIEWINVOICEPDF}/${consumerNo}`, options);
	}

	downloadBillDocument(consumerNo: string) {
		//alert("Bill Service"+consumerNo);
		const headers = new Headers({ 'Content-Type': 'application/pdf' });
		const options = new RequestOptions({ headers: headers });
		options.responseType = ResponseContentType.Blob;
		return this.http.get(`${AppSettings.IPCL_API}/${consumerNo}${AppSettings.DOWNLOADORVIEWINVOICEBILLPDF}`, options);
	}

	getBlroRegionNameWiseBroadcastData(blroRegionName) {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETBLROREGIONBROADCASTDATA + '/' + blroRegionName);
	}

	getBlroRegionIdWiseBroadcastData(blroRegionId) {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETBLROREGIONIDWISEBROADCASTDATA + '/' + blroRegionId);
	}

	getMouzaZoneWiseBroadcastData(blroRegion, mouzaZoneName) {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETMOUZAZONEBROADCASTDATA + '/' + blroRegion + '/' + mouzaZoneName);
	}

	getMouzaZoneIDWiseBroadcastData(mouzaZoneId, blroRegionId) {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETBLROREGIONMOUZAZONEIDWISEBROADCASTDATA + '/' + mouzaZoneId + '/' + blroRegionId);
	}

	getPaymentDetails(consumerId: String) {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETPAYMENTDETAILSBYCONSUMERID + '/' + consumerId);
	}

	filterPaymentDetailsByConsumerId(filterString, consumerId: String) {
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + filterString + AppSettings.FILTERPAYMENTDETAILSByCONSUMERID + '/' + consumerId);
	}

	saveFeedback(feedbackModel: any) {
		return this.httpClient.post(`${AppSettings.IPCL_API}${AppSettings.SAVEFEEDBACK}`, feedbackModel);
	}

	getConnectionManagementHistory(consumerId: any): Observable<any> {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETCONNECTIONMANAGEMENTHISTORY + '/' + consumerId);
	}

	saveConnectionManagementDetails(postData: any) {
		return this.httpClient.post(`${AppSettings.IPCL_API}${AppSettings.SAVECONNECTIONMANAGEMENTDETAILS}`, postData);
	}

	getTariffList() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETTARIFFDETAILS);
	}
	getFirstQuestion() {
		return this._baseProxy.get(AppSettings.IPCL_API + AppSettings.GETFIRSTQUESTION);
	}
	getUniqueAns(chatUniqueQuery) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.GETUNIQUEANS, chatUniqueQuery);
	}
	getAnswer(chatUniqueQuery) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.GETANSWER, chatUniqueQuery);
	}
	getNextQuestion(chatUniqueQuery) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.GETNEXTQUESTION, chatUniqueQuery);
	}
	getUserQuery(chatbotBasicQObj) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.GETUSERQUERY, chatbotBasicQObj);
	}


	resetPassword(data: any, token: any): Observable<any> {
		let httpHeaders = new HttpHeaders()
			.set('Content-Type', 'application/json');
		let queryParams = new HttpParams()
			.set('token', token)
			.set('password', data.password)
			.set('confirmPassword', data.confirmPassword);

		return this.httpClient.get(AppSettings.IPCL_API + AppSettings.RESETPASSWORD, {
			headers: httpHeaders,
			params: queryParams,
			responseType: 'text'
		});
	}
	getConsumerDetailsfromService(requestedId: any) {
		var self = this;
		this.getConsumerInfoByConsumerId(requestedId).subscribe(
			(data) => {
				this.userdetailsObj.emit(data);
				console.log("UserData >> ", JSON.stringify(data));
			},
			(error) => {

				//this.serviceOn = false;
			},
			() => {

			});
	}
	authenticateComplainConsumerNoAndMobile(data) {
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');

		return this._baseProxy.post(AppSettings.IPCL_API + AppSettings.AUTHENTICATECOMPLAINCONSUMERNOANDMOBILE, data,
			{
				headers: theaders
			}).map(res => res);

	}

	solarInfo(param) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.SOLARINFO, param);
	}

	solarGuide() {
		const headers = new Headers({ 'Content-Type': 'application/pdf' });
		const options = new RequestOptions({ headers: headers });
		options.responseType = ResponseContentType.Blob;
		return this.http.get(`${AppSettings.IPCL_API}${AppSettings.SOLARGUIDE}`, options);
	}

	solarPVform() {
		const headers = new Headers({ 'Content-Type': 'application/pdf' });
		const options = new RequestOptions({ headers: headers });
		options.responseType = ResponseContentType.Blob;
		return this.http.get(`${AppSettings.IPCL_API}${AppSettings.SOLARPVFORM}`, options);
	}

	validateCheckMeter(param) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.CHECKMETER, param);
	}

	prepaidPayment(param) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.PREPAIDPAYMENT, param);
	}

	getPrepaidMeterDetail(param) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.GETPREPAIDMETERDETAIL, param);
	}

	prepaidPaymentInitiate(param) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.PREPAIDPAYMENT, param);
	}

	balanceEnquiry(consumerNumber) {
		// return this.httpClient.post(AppSettings.IPCL_API + AppSettings.BALANCEENQUIRY, param);
		return this.httpClient.get(AppSettings.IPCL_API + AppSettings.BALANCEENQUIRY +'/'+ consumerNumber + '/null');
	}

	balanceEnquiryRevised(consumerNumber) {
		// return this.httpClient.post(AppSettings.IPCL_API + AppSettings.BALANCEENQUIRY, param);
		return this.httpClient.get(AppSettings.IPCL_API + AppSettings.BALANCEENQUIRYREVISED +'/'+ consumerNumber + '/null');
	}

	prepaidTransactionStatus(transactionId, connectionNo) {
		// return this.httpClient.post(AppSettings.IPCL_API + AppSettings.BALANCEENQUIRY, param);
		return this.httpClient.get(AppSettings.IPCL_API + AppSettings.TRANSACTIONSTATUS +'/'+ transactionId +'/'+ connectionNo);
	}

	postRazorpayPrepaidResponse(data) {
		console.log("XXXXXXXX===Pay Emd Details====XXXXXXXXXXX")
		var theaders = new Headers();
		theaders.append('Content-Type', 'application/json');
		console.log(data);

		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.SAVEPREPAIDRAZORPAYRESPONSE, data);
	}

	prepaidPaymentConsHistories(param) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.PREPAIDPAYMENTCONSHISTORIES, param);
	}

	prepaidConsumptionHistories(param) {
		return this.httpClient.post(AppSettings.IPCL_API + AppSettings.GETPREPAIDCONSUMPTIONHISTORIES, param);
	}

	getProcessStatusByOldCapital(uuid: string) {
		console.log("Meter recharge status ");
		//this.transIDD = transactionIds;
		return this._baseProxy.get(AppSettings.IPCL_API + '/' + AppSettings.PROCESSSTATUSBYOLDCAPITAL + '?uuid='+ uuid);

	}
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/services/http.service.ts